import React, { useCallback } from 'react';
import Section from '../v2/Section/Section';
import { Stack } from '../v2/Stack/Stack';
import Icon from '../v2/Icon/Icon';
import Spacer from '../v2/Spacer/Spacer';
import Typography from '../v2/Typography/Typography';
import Button from 'components/v2/Button/Button';
import { useModal } from '../v2/Modal/useModal';
import { useTranslation } from 'utils/translation';

type Props = {
  onClose?(): void;
};

const DemoLimitReached = ({ onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Section>
      <Stack direction="column" align="center">
        <Icon name="fa-light fa-triangle-exclamation fa-3x" color="warning" />
        <Spacer size={2} />
        <Typography variant="h2">{t('demo_limit_reached.title')}</Typography>
        <Spacer size={2} />
        <Typography align="center">
          {t('demo_limit_reached.info')}
          <br />
          {t('demo_limit_reached.upgrade')}
        </Typography>
      </Stack>
      <Spacer size={2} />
      <Stack align="center" direction="column">
        <Spacer size={3} />
        <Button
          onClick={() => {
            window.open('https://www.quodoc.com/contact');
            onClose?.();
          }}
          startIcon={<Icon name="fa-regular fa-bolt" />}
        >
          {t('demo_limit_reached.action')}
        </Button>
      </Stack>
    </Section>
  );
};

export const useDemoLimitReachedModal = () => {
  const modal = useModal();

  return useCallback(() => {
    modal.open(({ close }) => <DemoLimitReached onClose={close} />, {
      size: 'small',
    });
  }, [modal.open]);
};
